export default __webpack_public_path__ + "static/media/cemredort.9135acb2.jpg";